module.exports = __webpack_public_path__ + "img/Big.f3827f57.png";